// import React from "react";
// import { ShoppingCart } from "lucide-react";
// import { useSelector } from "react-redux";
// import {
//   selectCartData,
//   witoutDiscoutTotalPrice,
// } from "../../ReduxSlice/BookSlice";

// const NavbarCart = ({ openModal, paymentMode }) => {
//   const cartItems = useSelector(selectCartData);
//   const totalPrice = useSelector(witoutDiscoutTotalPrice);

//   const totalQuantity = cartItems.reduce(
//     (sum, item) => sum + item.quantity,
//     0
//   );

//   const handleCartClick = () => {
//     if (totalPrice <= 0) {
//       alert("Your cart is empty");
//       return;
//     }
//     openModal(true);
//     paymentMode("cart_item");
//   };

//   return (
//     <button
//       onClick={handleCartClick}
//       className="relative p-2 rounded-full hover:bg-gray-100 transition"
//     >
//       <ShoppingCart className="w-6 h-6 text-gray-700" />

//       {/* 🔴 Badge */}
//       {totalQuantity > 0 && (
//         <span className="absolute -top-1 -right-1 bg-red-600 text-white text-xs px-1.5 rounded-full">
//           {totalQuantity}
//         </span>
//       )}
//     </button>
//   );
// };

// export default NavbarCart;


import React from "react";
import { ShoppingCart } from "lucide-react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  selectCartData,
  witoutDiscoutTotalPrice,
} from "../../ReduxSlice/BookSlice";

const NavbarCart = () => {
  const navigate = useNavigate();
  const cartItems = useSelector(selectCartData);
  const totalPrice = useSelector(witoutDiscoutTotalPrice);

  const totalQuantity = cartItems.reduce(
    (sum, item) => sum + item.quantity,
    0
  );

  const handleCartClick = () => {
    if (totalPrice <= 0) {
      alert("Your cart is empty");
      return;
    }

    // ✅ Navigate to full screen cart page
    navigate("/pos/cart");
  };

  return (
    <button
      onClick={handleCartClick}
      className="
        p-3 rounded-full 
        bg-white 
        text-[#1E40AF] 
        flex items-center justify-center
        transform transition 
        duration-300 ease-in-out
        hover:scale-110 
        hover:shadow-lg 
        hover:bg-[#BFDBFE]
        active:scale-95
      "
    >
      <ShoppingCart className="w-8 h-8" />

      {/* 🔴 Cart Badge */}
      {totalQuantity > 0 && (
        <span className="absolute -top-1 -right-1 bg-red-600 text-white text-[10px] min-w-[18px] h-[18px] flex items-center justify-center rounded-full">
          {totalQuantity}
        </span>
      )}
    </button>
  );
};

export default NavbarCart;
